<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close="abort">{{data.abort}}</button>
  <button mat-button mat-dialog-close="confirm" cdkFocusInitial>{{data.confirm}}</button>
</mat-dialog-actions>
